module.exports = __webpack_public_path__ + "img/avion.287091d8.jpg";